import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CheckCircleIcon = (props: SVGProps) => {
  // 48px intrinsic size, not SpriteIcon's 24px default. Consumer w-*/h-*/size-* classes still win.
  return (
    <SpriteIcon spriteId="check-circle" width="48" height="48" {...props} />
  );
};

export { CheckCircleIcon };
